import {MarkerBase} from "../components/map/service/marker-base";
import {latLng, marker, Marker, popup} from "leaflet";
import {DeviceHttpService} from "../../../http-requests/device-http.service";
import {Injectable, OnDestroy} from "@angular/core";
import {ShardHttpService} from "../../../owner/x-http-requests/shard-http.service";
import {ShardDto} from "../../../models/admin_owner/shard/shard-dto";
import {ReducedDeviceLocationDto} from "../../../models/device/reduced-device-location-dto";
import {GlobalAlertService} from "../../../_services/global-alert.service";
import {GeolocationDto} from "../../../models/misc/position/geolocation-dto";
import {LocationProcessor} from "../utils/location-processor";
import {OrderHttpService} from "../../../http-requests/order-http.service";


@Injectable()
export class GeolocationStore extends MarkerBase implements OnDestroy {
  companies: ShardDto[] = [];
  deviceLocations: { [key: string]: ReducedDeviceLocationDto[] } = {};
  activeCompany: string = "";
  activeDevices: ReducedDeviceLocationDto[] = [];
  sidebarDevices: ReducedDeviceLocationDto[] = [];
  shardLocations: { [key: string]: GeolocationDto } = {};
  cachedMarkers: { [key: string]: any[] } = {}
  cachedBundles: { [key: string]: { lat: number, lng: number, count: number }[] } = {}

  isFarFromLocation: { [key: string]: boolean } = {}
  loadingDevices: boolean = false;
  loadingOrderCounts: boolean = false;
  cachedOrderCounts: { [key: string]: { count: number, start: Date, end: Date }[] } = {}

  constructor(private deviceHttpService: DeviceHttpService,
              private shardHttpService: ShardHttpService,
              private globalAlertService: GlobalAlertService,
              private orderHttpService: OrderHttpService) {
    super()
    //this.shardLocations = {"id": {"latitude": 0, "longitude": 0}}
    this.initialize()
    this.initialized = true;
    setTimeout(() => {
      this.center = latLng(51.032267969831, 13.706916853300902)
      this.zoom = 11
    })
  }

  initialize() {
    this.fetchShards();
  }

  setActiveShard(shardId: string) {
    this.sidebarDevices = [];
    this.activeDevices = []
    if (!shardId || shardId == "") {
      for (let shard in this.deviceLocations) {
        this.sidebarDevices = this.activeDevices.concat(this.deviceLocations[shard])
      }
    } else {
      this.sidebarDevices = this.deviceLocations[shardId];
    }
    this.selectAllDevices()
  }

  fetchShards() {
    this.shardHttpService.list("").subscribe((data) => {
      this.companies = data;
    })
  }

  fetchOrderCount(shardId: string) {
    if (shardId in this.cachedOrderCounts) {
      return
    }
    this.loadingOrderCounts = true
    this.orderHttpService.getOrderCountFromShard(shardId, 30).subscribe((data) => {
      this.cachedOrderCounts[shardId] = data
      this.loadingOrderCounts = false
    })
  }

  fetchDeviceData(shardId: string) {
    // todo switch data
    if (shardId in this.deviceLocations) {
      this.setActiveShard(shardId)
      return
    }

    this.loadingDevices = true
    this.deviceHttpService.dictReducedDeviceLocation(shardId).subscribe((data) => {
      this.deviceLocations[shardId] = data[shardId]
      this.setActiveShard(shardId)
      this.loadingDevices = false
    })
  }

  selectAllDevices() {
    this.activeDevices = this.sidebarDevices;
    this.displayDevices()
  }

  updateDeviceList(device: ReducedDeviceLocationDto) {
    if (this.inActiveDeviceList(device)) {
      this.activeDevices = this.activeDevices.filter((value) => value !== device)
    } else {
      this.activeDevices = [device]
    }
    this.displayDevices()
  }

  displayDevices() {


    this.createBundles()
  }

  selectCompany(company: string) {
    this.activeCompany = company;
    this.fetchDeviceData(company);
    this.fetchOrderCount(company);
  }

  createBundles() {
    // @ts-ignore
    this.markers = []

    for (let device of this.activeDevices) {
      let _markers: any[] = []
      if (device.id in this.cachedMarkers) {
        for (let marker of this.cachedMarkers[device.id]) {
          this.markers.push(marker)
        }
        continue
      }

      let bundle = LocationProcessor.processLocation(device.id, device.deviceLocations, _markers, this.isFarFromLocation)
      for (let marker of _markers) {
        this.markers.push(marker)
      }
      this.cachedMarkers[device.id] = _markers
      this.cachedBundles[device.id] = bundle
    }
    for (let marker in this.markers) {
      if (this.checkIsFarFromLocation(marker)) {
      }
    }
  }

  getCachedBundles(deviceId: string): { lat: number, lng: number, count: number }[] {
    if (deviceId in this.cachedMarkers)
      return this.cachedBundles[deviceId]
    return []
  }

  checkIsFarFromLocation(deviceId: string): boolean {

    return true
  }


  centerMap(lat: number, long: number) {
    this.center = latLng(lat, long)
    /*let center = this.findCenterOfMarkers(markers);
    let newOptions = {...this.options}
    newOptions.center = latLng(center.lat, center.long)
    this.options = newOptions*/
  }

  ngOnDestroy() {
  }

  /*override updateMarkers() {
    this.markers = this.parseDevicesToMap(this.activeDevices);
  }

  parseDevicesToMap(devices: ReducedDeviceLocationDto[]): Marker<any>[] {
    let layers: Marker<any>[] = [];
    for (let a in devices) {
      let device = devices[a];
      let minMax = this.findMinMaxLat(device);
      let layer = this.createLayer(minMax.minLat.latitude, minMax.minLat.longitude, device.id);
      layers.push(layer);
      layer = this.createLayer(minMax.maxLat.latitude, minMax.maxLat.longitude, device.id);
      layers.push(layer);
      layer = this.createLayer(minMax.minLong.latitude, minMax.minLong.longitude, device.id);
      layers.push(layer);
      layer = this.createLayer(minMax.maxLong.latitude, minMax.maxLong.longitude, device.id);
      layers.push(layer);
    }

    return layers;
  }*/

  findCenterOfMarkers(markers: Marker<any>[]) {
    if (markers.length === 0) {
      this.globalAlertService.createAndShow("Keine Koordinaten fuer das Geraet gefunden", "info")
      return {"lat": 0, "long": 0}
    }
    let lat = 0;
    let long = 0;
    for (let marker of markers) {
      lat += marker.getLatLng().lat;
      long += marker.getLatLng().lng;
    }
    return {
      "lat": lat / markers.length,
      "long": long / markers.length
    }
  }

  findMinMaxLat(device: ReducedDeviceLocationDto): {
    "minLat": GeolocationDto,
    "maxLat": GeolocationDto,
    "minLong": GeolocationDto,
    "maxLong": GeolocationDto
  } {
    if (device.deviceLocations.length === 0) {
      this.globalAlertService.createAndShow("Keine Koordinaten fuer das Geraet gefunden " + device.id, "info")
    }

    let minLatGeolocation = device.deviceLocations[0];
    let minLongGeolocation = device.deviceLocations[0];
    let maxLatGeolocation = device.deviceLocations[0];
    let maxLongGeolocation = device.deviceLocations[0];
    for (let geolocation of device.deviceLocations) {
      if (geolocation.latitude < minLatGeolocation.latitude) minLatGeolocation = geolocation;
      if (geolocation.latitude > maxLatGeolocation.latitude) maxLatGeolocation = geolocation;
      if (geolocation.longitude < minLongGeolocation.longitude) minLongGeolocation = geolocation;
      if (geolocation.longitude > maxLongGeolocation.longitude) maxLongGeolocation = geolocation;
    }
    return {
      "minLat": minLatGeolocation,
      "maxLat": maxLatGeolocation,
      "minLong": minLongGeolocation,
      "maxLong": maxLongGeolocation
    }
  }


  createLayer(latitude: number, longitude: number, deviceId: string) {
    let layer = marker([latitude, longitude]);
    layer.bindPopup(
      popup().setContent('Device ID: ' + deviceId)
    )
    return layer;
  }

  inActiveDeviceList(device: ReducedDeviceLocationDto) {
    return this.activeDevices.includes(device);
  }

  isDeviceFarFromCenter(deviceId: string): number {
    //check if device is in dict
    if (deviceId in this.isFarFromLocation && this.isFarFromLocation[deviceId]) {
      return 0
    }
    return 1
  }

  markerCount(deviceId: string): number {
    if (deviceId in this.cachedMarkers) {
      return this.cachedMarkers[deviceId].length
    }
    return 0
  }
}
